// Service
import CFiltro from '../base/CFiltro';
import CConsultaAgregacao from '../temas/base/CConsultaAgregacao';
import type CConsultaValores from '../temas/base/CConsultaValores';
import CBaseControllerAPI from '@/services/base/CBaseControllerAPI';
import type CResultadoAgregacao from '../temas/base/CResultadoAgregacao';
import CRelatorioTempoDeUsoAplicacao from './CRelatorioTempoDeUsoAplicacao';
import type CResponseConsultaPaginada from '../base/CResponseConsultaPaginada';
import CRelatorioRecursosMaisUtilizados from './CRelatorioRecursosMaisUtilizados';
import CMonitoramentoTempoUso, { CMapeamentoMonitoramentoTempoUso } from './CMonitoramentoTempoUso';

export default class MonitoramentoTempoUsoController extends CBaseControllerAPI<CMonitoramentoTempoUso> {
  readonly endpoints = {
    incluir: '/v1/monitoramentoTempoUso/incluir',
    registrar: '/v1/monitoramentoTempoUso/registrar',
    atualizar: '/v1/monitoramentoTempoUso/atualizar',
    filtrar: '/v1/monitoramentoTempoUso/filtrar',
    agregar: '/v1/monitoramentoTempoUso/agregar',
    valores: '/v1/monitoramentoTempoUso/valores',
  };

  constructor() {
    super();
  }

  async tempoDeUsoDaAplicacao(pFiltro: CFiltro<CMonitoramentoTempoUso>) {
    try {
      pFiltro.utilizaLimite = false;
      pFiltro.utilizaTotalRegistros = false;
      const agregar = new CConsultaAgregacao<CMonitoramentoTempoUso>({
        codificacao: '',
        query: pFiltro,
        grupos: ['usuario', 'cliente', 'plataforma', 'dia', 'mes', 'ano'],
        metricas: [
          {
            campo: 'tempoEmMS',
            operador: 'sum',
            distinct: false,
          },
          {
            campo: 'sessaoId',
            operador: 'count',
            distinct: true,
          },
        ],
      });

      const lResponse = await this.agregar(agregar);

      return new CRelatorioTempoDeUsoAplicacao(lResponse);
    } catch (error) {
      throw error;
    }
  }

  async recursoMaisUtilizados(pFiltro: CFiltro<CMonitoramentoTempoUso>) {
    try {
      pFiltro.utilizaLimite = false;
      pFiltro.utilizaTotalRegistros = false;
      const agregar = new CConsultaAgregacao<CMonitoramentoTempoUso>({
        codificacao: '',
        query: pFiltro,
        grupos: ['usuario', 'cliente', 'plataforma', 'identificador'],
        metricas: [
          {
            campo: 'tempoEmMS',
            operador: 'sum',
            distinct: false,
          },
          {
            campo: 'sessaoId',
            operador: 'count',
            distinct: true,
          },
        ],
      });

      const lResponse = await this.agregar(agregar);

      return new CRelatorioRecursosMaisUtilizados(lResponse);
    } catch (error) {
      throw error;
    }
  }

  async agregar(
    pParams: CConsultaAgregacao<CMonitoramentoTempoUso>,
  ): Promise<CResponseConsultaPaginada<CResultadoAgregacao<CMonitoramentoTempoUso>>> {
    try {
      pParams.query = CFiltro.toQuery(pParams.query, new CMapeamentoMonitoramentoTempoUso() as any);

      const body = {
        ...pParams.toObject(),
      };

      const { data } = await this.rest.post<CResponseConsultaPaginada<CResultadoAgregacao<CMonitoramentoTempoUso>>>(
        this.endpoints.agregar,
        body,
      );
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async registrar(pMonitoramento: Partial<CMonitoramentoTempoUso>): Promise<CMonitoramentoTempoUso> {
    try {
      const { data } = await this.rest.post<CMonitoramentoTempoUso>(this.endpoints.registrar, pMonitoramento);

      return new CMonitoramentoTempoUso(data);
    } catch (error) {
      throw error;
    }
  }

  async incluir(): Promise<CMonitoramentoTempoUso> {
    try {
      const { data } = await this.rest.post<CMonitoramentoTempoUso>(this.endpoints.incluir);

      return new CMonitoramentoTempoUso(data);
    } catch (error) {
      throw error;
    }
  }

  async atualizar(pRegistro: CMonitoramentoTempoUso): Promise<CMonitoramentoTempoUso> {
    try {
      const { data } = await this.rest.post<CMonitoramentoTempoUso>(this.endpoints.atualizar, pRegistro);

      return new CMonitoramentoTempoUso(data);
    } catch (error) {
      throw error;
    }
  }

  async buscar(): Promise<CMonitoramentoTempoUso | null> {
    try {
      const { data } = await this.rest.post<CResponseConsultaPaginada<CMonitoramentoTempoUso>>(this.endpoints.filtrar);

      if (!data || data.registros.length == 0) {
        return null;
      }

      return new CMonitoramentoTempoUso(data.registros[0]);
    } catch (error) {
      throw error;
    }
  }

  async valores(pParams: CConsultaValores): Promise<string[]> {
    try {
      // Define sempre com resultados distintos
      pParams.query.distinct = true;

      const body = {
        query: CFiltro.toQuery(pParams.query, new CMapeamentoMonitoramentoTempoUso() as any),
      };

      const { data } = await this.rest.post<CResponseConsultaPaginada<string>>(this.endpoints.valores, body);

      return data.registros;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
